const cleanData = (values) => {
  let filterArray = [
    "_add_addendum_c_job_duties",
    "_add_addendum_c_pay_deductions",
    "_add_addendum_c_job_requirements",
    "add_values_field",
    "_",
    "pages",
    "__typename",
  ];
  let data = values;
  filterArray.map((x) => {
    delete data[x];
    return data;
  });
  // console.log("DATA ------------------------------", data, values);
  if (!values["files"]) {
    values["files"] = [];
  }
  if (
    values["eta_790a_i5_signature"] &&
    typeof values["eta_790a_i5_signature"] === "object"
  ) {
    values["files"] = values["files"].concat(values["eta_790a_i5_signature"]);
    values["eta_790a_i5_signature"] = "YES";
  }

  if (values["files"]) {
    if (values["files"].length > 0) {
      values["eta_790a_i5_signature"] = "YES";
    } else {
      values["eta_790a_i5_signature"] = "NO";
    }
    for (let j = 0; j < values["files"].length; j++) {
      data["files"][j].size = data["files"][j].size.toString();
      delete data["files"][j].fileTypes;
      data["files"][j].lastModified = data["files"][j].lastModified.toString();
      if (data["files"][j].__typename) {
        delete data["files"][j].__typename;
      }
    }
  }
  if (values["eta_790a_addendum_b_housing"]) {
    for (let j = 0; j < values["eta_790a_addendum_b_housing"].length; j++) {
      if (
        values["eta_790a_addendum_b_housing"][j].housing_county_id &&
        values["eta_790a_addendum_b_housing"][j].housing_county_id.value
      ) {
        delete data["eta_790a_addendum_b_housing"][j].housing_county_id
          .__typename;
      }

      delete data["eta_790a_addendum_b_housing"][j].__typename;
      // if (
      //   values["eta_790a_addendum_b_housing"][j] &&
      //   values["eta_790a_addendum_b_housing"][j]["applicable_housing_standards"] &&
      //   values["eta_790a_addendum_b_housing"][j]["applicable_housing_standards"].length > 0
      // ) {
      //   console.log('WTF IS GOING ON', values)
      //   values["eta_790a_addendum_b_housing"][j]["applicable_housing_standards"]?.forEach((k) => {
      //     delete k.__typename;
      //   });
      // }
    }
  }

  if (values["eta_790a_addendum_c"]) {
    for (let j = 0; j < values["eta_790a_addendum_c"].length; j++) {
      delete data["eta_790a_addendum_c"][j].__typename;
    }
  }
  if (values["eta_790a_addendum_a"]) {
    for (let j = 0; j < values["eta_790a_addendum_a"].length; j++) {
      delete data["eta_790a_addendum_a"][j].__typename;
    }
  }

  if (values["eta_790a_addendum_b_employment"]) {
    for (let j = 0; j < values["eta_790a_addendum_b_employment"].length; j++) {
      if (
        values["eta_790a_addendum_b_employment"][j] &&
        values["eta_790a_addendum_b_employment"][j].employment_county_id &&
        values["eta_790a_addendum_b_employment"][j].employment_county_id
          .__typename
      ) {
        delete data["eta_790a_addendum_b_employment"][j].employment_county_id
          .__typename;
      }

      if (
        data["eta_790a_addendum_b_employment"][j] &&
        data["eta_790a_addendum_b_employment"][j].__typename
      ) {
        delete data["eta_790a_addendum_b_employment"][j].__typename;
      }
    }
  }
  if (values["eta_790a_c5_work_county_id"]) {
    if (
      values["eta_790a_c5_work_county_id"] &&
      values["eta_790a_c5_work_county_id"].__typename
    ) {
      delete values["eta_790a_c5_work_county_id"].__typename;
    }
  }
  if (values["eta_790a_d5_housing_county_id"]) {
    if (
      values["eta_790a_d5_housing_county_id"] &&
      values["eta_790a_d5_housing_county_id"].__typename
    ) {
      delete values["eta_790a_d5_housing_county_id"].__typename;
    }
  }

  // if(values["eta_790a_c7_is_work_addendum_b_completed"]==="YES"){
  //   data["eta_790a_c7_is_work_addendum_b_completed"] = "1";
  // }
  // else if(values["eta_790a_c7_is_work_addendum_b_completed"]==="NO"){
  //   data["eta_790a_c7_is_work_addendum_b_completed"] = "0";
  // }

  if (values["eta_790a_d6_housing_type"] === "Employer") {
    data["eta_790a_d6_housing_type_employer"] = 1;
    values["eta_790a_d6_housing_type_rental"] = 0;
  }
  if (values["eta_790a_d6_housing_type"] === "Rental") {
    data["eta_790a_d6_housing_type_rental"] = 1;
    values["eta_790a_d6_housing_type_employer"] = 0;
  }

  if (
    values["eta_790a_addendum_b_housing"] &&
    values["eta_790a_addendum_b_housing"].length > 0
  ) {
    const arr = values["eta_790a_addendum_b_housing"];
    for (let i = 0; i < arr.length; i++) {
      if (
        arr[i]["housing_type"] &&
        arr[i]["housing_type"].length > 0 &&
        arr[i]["housing_type"] === "Employer"
      ) {
        data["eta_790a_addendum_b_housing"][i]["housing_type_employer"] = 1;
        data["eta_790a_addendum_b_housing"][i]["housing_type_rental"] = 0;
      }
      if (
        arr[i]["housing_type"] &&
        arr[i]["housing_type"].length > 0 &&
        arr[i]["housing_type"] === "Rental"
      ) {
        data["eta_790a_addendum_b_housing"][i]["housing_type_rental"] = 1;
        data["eta_790a_addendum_b_housing"][i]["housing_type_employer"] = 0;
      }
    }
  }

  if (
    values["eta_790a_d9_housing_standards_local"] &&
    typeof values["eta_790a_d9_housing_standards_local"] === "object"
  ) {
    data["eta_790a_d9_housing_standards_local"] =
      values["eta_790a_d9_housing_standards_local"][0];
  }
  if (
    values["eta_790a_d9_housing_standards_swa"] &&
    typeof values["eta_790a_d9_housing_standards_swa"] === "object"
  ) {
    data["eta_790a_d9_housing_standards_swa"] =
      values["eta_790a_d9_housing_standards_swa"][0];
  }
  if (
    values["eta_790a_d9_housing_standards_other_state"] &&
    typeof values["eta_790a_d9_housing_standards_other_state"] === "object"
  ) {
    data["eta_790a_d9_housing_standards_other_state"] =
      values["eta_790a_d9_housing_standards_other_state"][0];
  }
  if (
    values["eta_790a_d9_housing_standards_federal"] &&
    typeof values["eta_790a_d9_housing_standards_federal"] === "object"
  ) {
    data["eta_790a_d9_housing_standards_federal"] =
      values["eta_790a_d9_housing_standards_federal"][0];
  }
  if (
    values["eta_790a_d9_housing_standards_other"] &&
    typeof values["eta_790a_d9_housing_standards_other"] === "object"
  ) {
    data["eta_790a_d9_housing_standards_other"] =
      values["eta_790a_d9_housing_standards_other"][0];
  }
  if (
    values["eta_790a_d9_housing_standards_other_text"] &&
    typeof values["eta_790a_d9_housing_standards_other_text"] === "object"
  ) {
    data["eta_790a_d9_housing_standards_other_text"] =
      values["eta_790a_d9_housing_standards_other_text"][0];
  }

  if (
    values["eta_790a_b4a_certification_req"] &&
    typeof values["eta_790a_b4a_certification_req"] === "object"
  ) {
    data["eta_790a_b4a_certification_req"] =
      values["eta_790a_b4a_certification_req"][0];
  }
  if (
    values["eta_790a_b4b_driver_req"] &&
    typeof values["eta_790a_b4b_driver_req"] === "object"
  ) {
    data["eta_790a_b4b_driver_req"] = values["eta_790a_b4b_driver_req"][0];
  }
  if (
    values["eta_790a_b4c_background_req"] &&
    typeof values["eta_790a_b4c_background_req"] === "object"
  ) {
    data["eta_790a_b4c_background_req"] =
      values["eta_790a_b4c_background_req"][0];
  }
  if (
    values["eta_790a_b4d_drug_screen_req"] &&
    typeof values["eta_790a_b4d_drug_screen_req"] === "object"
  ) {
    data["eta_790a_b4d_drug_screen_req"] =
      values["eta_790a_b4d_drug_screen_req"][0];
  }
  if (
    !values["eta_790a_b4e_lifting_req"] ||
    values["eta_790a_b4e_lifting_req"] === undefined ||
    values["eta_790a_b4e_lifting_req"] === null ||
    (values["eta_790a_b4e_lifting_req"] &&
      values["eta_790a_b4e_lifting_req"].length <= 0)
  ) {
    values["eta_790a_b4f_lifting_lbs"] = null;
  }
  if (
    values["eta_790a_b4e_lifting_req"] &&
    typeof values["eta_790a_b4e_lifting_req"] === "object"
  ) {
    data["eta_790a_b4e_lifting_req"] = values["eta_790a_b4e_lifting_req"][0];
  }
  if (
    values["eta_790a_b4f_lifting_lbs"] &&
    typeof values["eta_790a_b4f_lifting_lbs"] === "object"
  ) {
    data["eta_790a_b4f_lifting_lbs"] = values["eta_790a_b4f_lifting_lbs"][0];
  }
  if (
    values["eta_790a_b4g_temperature_req"] &&
    typeof values["eta_790a_b4g_temperature_req"] === "object"
  ) {
    data["eta_790a_b4g_temperature_req"] =
      values["eta_790a_b4g_temperature_req"][0];
  }
  if (
    values["eta_790a_b4h_pushing_req"] &&
    typeof values["eta_790a_b4h_pushing_req"] === "object"
  ) {
    data["eta_790a_b4h_pushing_req"] = values["eta_790a_b4h_pushing_req"][0];
  }
  if (
    values["eta_790a_b4i_walking_req"] &&
    typeof values["eta_790a_b4i_walking_req"] === "object"
  ) {
    data["eta_790a_b4i_walking_req"] = values["eta_790a_b4i_walking_req"][0];
  }
  if (
    values["eta_790a_b4j_bending_req"] &&
    typeof values["eta_790a_b4j_bending_req"] === "object"
  ) {
    data["eta_790a_b4j_bending_req"] = values["eta_790a_b4j_bending_req"][0];
  }
  if (
    values["eta_790a_b4k_rep_motion_req"] &&
    typeof values["eta_790a_b4k_rep_motion_req"] === "object"
  ) {
    data["eta_790a_b4k_rep_motion_req"] =
      values["eta_790a_b4k_rep_motion_req"][0];
  }
  //this field is disabled by default currently and as such doesn't
  //track the defaulted value.
  if (
    values["eta_790_c1_clearance_order_type"] === null ||
    !values["eta_790_c1_clearance_order_type"]
  ) {
    data["eta_790_c1_clearance_order_type"] = "790A";
  }

  return data;
};

let validateOnLoad = [
  {
    if: {
      condition: "AND",
      fields: [
        { field: "prelim_5_is_livestock", is: "NO" },
        { field: "eta_790_a13_swa_state_id", is: null },
      ],
    },
    then: {
      setPageVisited: 13,
      setPageErrored: 13,
    },
  },
];

export { cleanData, validateOnLoad };
